import React from 'react';
import CardTournamentInfo from './CardTournamentInfo';
import './Cards.css';
import './HeroSection.css'
import { useLang } from '../i18n';

function U13Info() {
  const { t } = useLang();
  return (
    <div>
      <div className='cards'>
        <h1>{t('tournament.infoTitle')}</h1>
        <div className='cards__container'>
          <div className='cards__wrapper'>
            <ul className='cards__items'>
              <CardTournamentInfo 
                label1={t('tournament.entryFees')}
                text1={t('tournament.singles25')}
                text2={t('tournament.doubles20')}
                text5={t('tournament.feesPayment')}
              />
              <CardTournamentInfo 
                label1={t('tournament.shuttlesLabel')}
                text3={t('tournament.shuttlesBrand')}
                text4={t('tournament.shuttlesText')}
              />
            </ul>

            <div className='table-wrapper'>
            <table className='table'>
              <thead>
                <tr>
                  <th>
                    {t('tournament.day25')}
                    <span className='label time'>8:30</span>
                  </th>
                  <th>
                    {t('tournament.day26')}
                    <span className='label time'>8:30</span>
                  </th>
                  <th>
                    {t('tournament.day27')}
                    <span className='label time'>8:30</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>   {/* first row */}
                  <td> {/* first column - Friday */}
                    <span className='label size'>{t('tournament.mainEvent')}</span>   
                  </td>
                  <td> {/* second column - Saturday */}
                    <span className='label size'>{t('tournament.mainEvent')}</span> 
                  </td>
                  <td> {/* third column - Sunday */}
                    <span className='label size'>SF</span> 
                    <span className='label discipline'>WS</span>
                    <span className='label discipline'>MS</span>
                  </td>
                </tr>
                <tr>   {/* second row */}
                <td>-</td> {/* first column - Friday */}
                  <td> {/* second column - Saturday */}
                    <span className='label size'>SF</span> 
                    <span className='label discipline'>XD</span>
                    <span className='label discipline'>WD</span>
                    <span className='label discipline'>MD</span>
                  </td>
                  <td> {/* third column - Sunday */}
                    <span className='label size'>{t('tournament.finals')}</span> 
                    <span className='label discipline'>XD</span>
                    <span className='label discipline'>WD</span>
                    <span className='label discipline'>MD</span>
                    <span className='label discipline'>WS</span>
                    <span className='label discipline'>MS</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
            <ul className='cards__items'>
            <CardTournamentInfo 
              text3={t('tournament.provisionalNote')}
              text4={t('tournament.koSystemNote')}
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default U13Info;